var map = {
	"./Ball-0.9s-200px.svg": "51b5",
	"./big-icon-alert.svg": "2212",
	"./big-icon-eclipse.svg": "b9e9",
	"./big-icon-rising.svg": "ad0d",
	"./big-icon-unsupported.svg": "1d78",
	"./cashflow-loader/arrows.svg": "f6d2",
	"./cashflow-loader/pyramid.svg": "5605",
	"./cashflow-loader/sun.svg": "a393",
	"./cashflow-loader/wave.svg": "25d7",
	"./group@3x.jpg": "4ab4",
	"./header-bank-square-bottom.svg": "9de1",
	"./header-bank-square-top.svg": "955b",
	"./header-cc-square-top.svg": "c58f",
	"./header-green-bottom-square.svg": "4143",
	"./header-green-top-square.svg": "29b5",
	"./header-red-square-bottom.svg": "d654",
	"./header-red-square-top.svg": "0808",
	"./icons/arrow-down.svg": "e1a5",
	"./icons/arrow-up.svg": "554d",
	"./icons/icon-add.svg": "13d9",
	"./icons/icon-lock.svg": "29a8",
	"./icons/icon-small-check.svg": "a155",
	"./icons/icon-small-lock.svg": "7e2b",
	"./icons/left-arrow.svg": "192b",
	"./icons/no-icon.svg": "7775",
	"./icons/play-btn.svg": "d2b8",
	"./icons/shield-icon.svg": "edff",
	"./icons/shield_square.svg": "5b95",
	"./icons/wait-icon.svg": "6146",
	"./icons/whatsapp.svg": "d7c5",
	"./security-logos.png": "b97e",
	"./security-top-image.svg": "a068",
	"./spinner-big.svg": "0868"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7202";